// @ts-strict-ignore
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import { Box } from 'components/Box';
import { ClientOnly } from 'containers/ClientOnly';
import { useMainSelector } from 'modules/main/store';
import { setAdTypeOnPageLoad } from 'modules/main/store/ducks/layout';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

export function BannerAds() {
  const { adTypeOnPageLoad, hideSalarySurveyAd } = useMainSelector((state) => ({
    adTypeOnPageLoad: state.layout.adTypeOnPageLoad,
    hideSalarySurveyAd: state.layout.hideSalarySurveyAd,
  }));
  const userEnvironment = useUserEnvironment();
  const { isUserLoaded, isEnvironmentLoaded } = userEnvironment;
  const dispatch = useDispatch();
  const history = useHistory();

  const hasSalarySurveyBanner =
    !history.location.pathname.includes('/salaries') &&
    !hideSalarySurveyAd &&
    promoteSalarySurvey({
      userEnvironment,
      allowDismissal: true,
    });

  useEffect(() => {
    if (
      isUserLoaded &&
      isEnvironmentLoaded &&
      adTypeOnPageLoad !== 'SALARY_SURVEY' &&
      hasSalarySurveyBanner
    ) {
      dispatch(setAdTypeOnPageLoad('SALARY_SURVEY'));
    }
  }, [
    isUserLoaded,
    isEnvironmentLoaded,
    dispatch,
    adTypeOnPageLoad,
    hasSalarySurveyBanner,
  ]);

  const hasResumeDatabaseBanner =
    !hasSalarySurveyBanner &&
    !['GRAD_FAIRS', 'SALARY_SURVEY'].includes(adTypeOnPageLoad) &&
    promoteResumeDatabase({
      userEnvironment,
      allowLoggedOut: true,
    });

  useEffect(() => {
    if (
      isUserLoaded &&
      isEnvironmentLoaded &&
      adTypeOnPageLoad !== 'RESUME_DB' &&
      hasResumeDatabaseBanner
    ) {
      dispatch(setAdTypeOnPageLoad('RESUME_DB'));
    }
  }, [
    isUserLoaded,
    isEnvironmentLoaded,
    adTypeOnPageLoad,
    hasResumeDatabaseBanner,
    dispatch,
  ]);

  return (
    <Box
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasResumeDatabaseBanner && <ResumeDatabaseBanner />}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </Box>
  );
}
